<template>
  <div class="iin-field-input-wrapper" :class="{disabled: props.disabled}">
    <input class="iin-field-input" :id="props.inputId" v-model="model" maxlength="12" :disabled="props.disabled"
           v-bind="$attrs" :class="{ 'border-transparent': props.borderTransparent, error: props.error }" ref="inputRef" />
    <div class="iin-mask">
      <span v-for="i in 12" :key="i" :class="{invisible: model[i - 1]}">_</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import {watch, useTemplateRef} from "vue";

interface IProps {
  inputId?: string;
  disabled?: boolean;
  borderTransparent?: boolean;
  error?: boolean;
}

const props = defineProps<IProps>();
const model = defineModel({default: '', type: String});

const inputRef = useTemplateRef('inputRef');

watch(model, (newValue) => {
  let value = newValue.replace(/\D/g, '');
  if (value.length > 12) {
    value = value.slice(0, 12);
  }
  if (value !== newValue) {
    model.value = value;
  }
});

defineExpose({
  focus() {
    inputRef.value?.focus();
  }
})
</script>

<style scoped>
.iin-field-input-wrapper {
  position: relative;
  width: 100%;
}

.iin-field-input, .iin-mask {
  padding: .625rem .75rem;
  width: 100%;
  font-size: .875rem;
  font-weight: 400;
  font-family: Golos, monospace;
  font-variant-numeric: tabular-nums;
  color: var(--BW-800);
}

.iin-field-input {
  border-radius: 8px;
  border: 1px solid var(--BW-400);
  outline: none;
  position: relative;
  z-index: 2;
  background: #fff;
  line-height: 1.125rem;

  &.border-transparent {
    border-color: transparent;
  }

  &:hover {
    border: 1px solid var(--BW-blue-2);
  }

  &:focus {
    border: 1px solid var(--BW-blue-4);
    box-shadow: none;
  }

  &.error {
    border-color: var(--BW-red-6);
  }

  &:disabled {
    background: var(--BW-200);
    border-color: var(--BW-400);
  }
}

.iin-mask {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  pointer-events: none;
  display: flex;
  align-items: center;
  color: var(--BW-400);
  margin: 1px;
  letter-spacing: 1.68px;
  user-select: none;
  z-index: 2;

  .invisible {
    visibility: hidden;
  }
}
</style>